<template>
  <div class="system-initialize">
    <main>

      <a-row style="padding:0 20px;">
        <a-form-model   style="margin-top: 15px">
          <a-col :span="24">
            <p>Tips: 初始化部门关联关系</p>
            <a-popconfirm
                title="是否初始化部门关联关系?"
                ok-text="确定"
                class="popconBtn"
                cancel-text="取消"
                placement="right"
                @confirm="orgInitialization"
            >
              <a-button  :loading="btnLoad"  icon="redo"
              >初始化部门</a-button
              >
            </a-popconfirm>


          </a-col>

          <a-col :span="24" class="sysSet-operate">

          </a-col>
        </a-form-model>
      </a-row>


    </main>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      submitLoad: false,
      loading: false,

    };
  },
  methods: {
    // 初始化部门
    orgInitialization(){
      this.btnLoad = true
      this.axios
          .get("/org/generateClosure")
          .then((res) => {
            this.btnLoad = false;
            if (res.code === 200) {
              notification.success({
                message: '初始化成功',
                duration: 3,
                customClass: "batch-import",
              })
            }
          })
          .catch((err) => {
            this.btnLoad = false;
            console.log(err);
          });
    },


  },
  beforeMount() {
  },
};
</script>

<style lang="scss" scoped>
.system-initialize {
  header {
    display: flex;
    align-items: flex-end;
    margin: -7px -8px 0;
    padding: 16px;
    letter-spacing: 1px;
    background-color: #fff;

    h3 {
      margin-bottom: 0;
      line-height: 20px;
      padding-left: 12px;
      border-left: 4px solid #3373f2;
      font-size: 18px;
      //font-weight: bold;
    }

    span {
      line-height: 16px;
      margin-left: 10px;
      color: #808080;
    }
  }

  main {
    margin: 16px 0px;
    background-color: #fff;
    //   padding: 0 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
    0 1px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 4px;


    ::v-deep .ant-form-item-label{
      font-weight: 600;
    }
    .ant-form-item label{
      font-weight: 600;
    }
    .logo-item{
      ::v-deep .ant-upload.ant-upload-select-picture-card{
        width: 200px;
        height: 60px;
      }
      ::v-deep .ant-form-item-children{
        width: 100%;
        display: flex;
        align-items: flex-end;
        margin-top: 5px;
        .imgShow{
          width: 184px;
          height: 60px;
          object-fit: cover;
        }
      }
      ::v-deep .ant-upload-picture-card-wrapper{
        width: 13%;
      }
      .tips-textColor{
        color: #d1d1d1;
        height: 35px;
      }
    }

    //按钮
    .sysSet-operate{
      text-align: right;
      margin-top: 385px;
      .ant-btn:nth-child(1){
        margin-right: 15px;
        background-color: #ecf0fe;
        color: #3373f2;
        letter-spacing: 1px;
      }
      .ant-btn:nth-child(2){
        width: 70px;
      }
    }

  }
}
</style>
